import { useMemo } from 'react'
import useAccount from './useAccount'

/**
 * Hook to determine if a table path represents a user table
 * @param path - The table path to check
 * @returns boolean indicating if the table is a user table
 */
const useIsUserTable = (path?: string): boolean => {
  const account = useAccount()

  const isUserTable = useMemo(() => {
    if (!path || !account.user) return false
    const userEmail = account.user.session_info?.email || ''
    return path.toLowerCase().startsWith(`tables/user/${userEmail.toLowerCase()}`)
  }, [path, account.user])

  return isUserTable
}

export default useIsUserTable
